import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
import GuildIcon from '../guild_icon.png';

const features = [
    {
        title: "エリート専門家集団",
        description: "Microsoft, AWS, Amazon等を経験したベテラン・高スキルメンバーが支援します。"
    },
    {
        title: "ハンズオンサポート",
        description: "技術的な助言から実装の伴走支援まで、アドバイザリーを提供します（準委任契約）。"
    },
    {
        title: "迅速かつ効率的",
        description: "小規模企業のため無駄なコストがなく、事務手続が迅速です。"
    },
    {
        title: "小回りの利くチケットサービス",
        description: "セカンドオピニオンやちょっとした壁打ちに使えるチケット制サービスもご用意してます"
    }
];

const WhyUs = () => {
    return (
        <section id="why-us" className="py-20 bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
            <div className="container mx-auto px-4 md:px-6">
                <div className="flex flex-col md:flex-row items-center gap-12">
                    <div className="md:w-1/2">
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6 }}
                            viewport={{ once: true }}
                        >
                            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-6">
                                Project NEXUSが<br className="hidden md:block" />選ばれる理由
                            </h2>
                            <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
                                私たちは単なる技術者集団ではありません。「職人のギルド」のように、誇りと責任を持ってお客様の課題解決に取り組みます。
                            </p>

                            <div className="space-y-6">
                                {features.map((feature, index) => (
                                    <div key={index} className="flex items-start gap-4">
                                        <CheckCircle2 className="w-6 h-6 text-gray-900 dark:text-white flex-shrink-0 mt-1" />
                                        <div>
                                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-1">{feature.title}</h3>
                                            <p className="text-gray-600 dark:text-gray-300">{feature.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </motion.div>
                    </div>

                    <div className="md:w-1/2 flex justify-center">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.6 }}
                            viewport={{ once: true }}
                            className="relative w-full max-w-md aspect-square bg-gradient-to-br from-gray-800 to-black rounded-2xl p-8 flex flex-col items-center justify-center text-white shadow-2xl rotate-3 hover:rotate-0 transition-transform duration-500"
                        >
                            <img
                                src={GuildIcon}
                                alt="Guild Icon"
                                className="w-3/4 h-auto mb-6 opacity-90 mix-blend-screen"
                            />
                            <div className="text-center">
                                <h3 className="text-3xl font-bold mb-2">専門家が集う</h3>
                                <h3 className="text-3xl font-bold mb-4">「職人ギルド」</h3>
                                <p className="text-gray-400 text-sm">技術アドバイザリ & プロジェクト伴走支援</p>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyUs;
